<template>
  <button
    :data-testid="dataTest"
    :class="computedClass"
    :id="id"
    :type="type"
    :disabled="!loaded || disabled"
    :ref="reference"
    @click.prevent="click"
  >
    <slot></slot>
    <div :id="recaptchaId" data-size="invisible" />
  </button>
</template>

<script type="text/javascript">
import { EventBus } from "@/assets/js/EventBus";
export default {
  props: {
    dataTest: {
      type: String,
      required: true
    },
    sitekey: {
      type: String,
      required: true
    },
    badge: {
      type: String,
      required: false,
      default: "bottomleft"
    },
    theme: {
      type: String,
      required: false,
      default: "dark"
    },
    validate: {
      type: Function,
      required: false
    },
    callback: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      required: false
    },

    reference: {
      type: String,
      required: false
    },

    type: {
      type: String,
      required: false,
      default: "submit"
    }
  },
  data: function() {
    return {
      widgetId: false,
      loaded: false
    };
  },
  methods: {
    render: function() {
      if (typeof grecaptcha !== "undefined") {
        /*&& grecaptcha.render) {*/
        this.widgetId = grecaptcha.enterprise.ready(async () => {
          const token = await grecaptcha.enterprise.execute(this.sitekey, {
            action: "LOGIN"
          });
        });
        /*this.widgetId = grecaptcha.render(this.recaptchaId, {
          sitekey: this.sitekey,
          size: "invisible",
          badge: this.badge,
          theme: this.theme,
          callback: token => {
            this.callback(token);
            grecaptcha.reset(this.widgetId);
          }
        });
        */
        this.loaded = true;
      } else {
        this.renderWait();
      }
    },
    renderWait: function() {
      const self = this;
      setTimeout(function() {
        if (typeof grecaptcha !== "undefined" && grecaptcha.render) {
          self.render();
        } else {
          self.renderWait();
        }
      }, 100);
    },
    click: function() {
      if (!this.validate || (this.validate && this.validate() !== false))
        /*grecaptcha.execute();*/
        grecaptcha.enterprise.ready(() => {
          grecaptcha.enterprise
            .execute(this.sitekey, {
              action: "LOGIN"
            })
            .then(token => {
              this.callback(token);
            })
            .catch(() => {
              console.log("ERROR validate captcha:");
              /** invalid reCaptcha score */
            });
        });
    }
  },
  computed: {
    computedClass: function() {
      var classArray = this.class ? this.class.split(" ") : [];
      if (this.value) {
        classArray.push("invisible-recaptcha");
      }
      return classArray;
    },
    recaptchaId: function() {
      return "vue-invisible-recaptcha-" + this._uid;
    }
  },
  mounted: function() {
    if (typeof grecaptcha === "undefined") {
      var script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/enterprise.js?render=" + this.sitekey;
      script.onload = this.renderWait;
      document.head.appendChild(script);
    } else {
      this.render();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/recaptcha/InvisibleRecaptcha.vue